module.exports = __webpack_public_path__ + "static/media/top-friends-video.57f97c7e.mp4";